// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Styles for EmojiVerificationScreen component
 * Reusable component for any verification type
 */

.emoji-verification-screen {
  width: 100%;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.emoji-verification-content {
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Instructions */
.emoji-verification-instructions {
  margin-bottom: 30px;
  font-size: 16px;
  color: #666;
  text-align: center;
  line-height: 1.5;
}

/* Emoji Grid */
.emoji-verification-emojis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
  gap: 15px;
  width: 100%;
  max-width: 450px;
  margin-bottom: 30px;
  padding: 0 10px;
}

.emoji-verification-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px 10px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: all 0.2s ease;
  min-height: 90px;
}

.emoji-verification-item:hover {
  background: #e9ecef;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.emoji-verification-icon {
  font-size: 36px;
  margin-bottom: 8px;
  line-height: 1;
  user-select: none;
}

.emoji-verification-name {
  font-size: 12px;
  color: #666;
  text-align: center;
  font-weight: 500;
  line-height: 1.2;
}

/* Actions */
.emoji-verification-actions {
  display: flex;
  gap: 12px;
  width: 100%;
  max-width: 400px;
  padding: 0 10px;
}

.emoji-verification-actions .btn {
  flex: 1;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.emoji-verification-reject {
  background: #dc3545;
  color: white;
  border: none;
}

.emoji-verification-reject:hover:not(:disabled) {
  background: #c82333;
  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
}

.emoji-verification-confirm {
  background: #28a745;
  color: white;
  border: none;
}

.emoji-verification-confirm:hover:not(:disabled) {
  background: #218838;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
}

.emoji-verification-actions .btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Waiting State */
.emoji-verification-waiting {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  text-align: center;
}

.emoji-verification-waiting .spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f0f0f0;
  border-top: 3px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

.emoji-verification-waiting p {
  font-size: 16px;
  color: #666;
  margin: 0;
}

/* Error State */
.emoji-verification-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  text-align: center;
}

.emoji-verification-error p {
  font-size: 16px;
  color: #dc3545;
  margin: 0;
}

/* Spinner animation */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .emoji-verification-emojis {
    grid-template-columns: repeat(auto-fit, minmax(70px, 1fr));
    gap: 10px;
  }

  .emoji-verification-item {
    padding: 12px 8px;
    min-height: 80px;
  }

  .emoji-verification-icon {
    font-size: 30px;
  }

  .emoji-verification-name {
    font-size: 11px;
  }

  .emoji-verification-actions {
    flex-direction: column;
  }

  .emoji-verification-actions .btn {
    width: 100%;
  }
}

/* Dark theme support */
@media (prefers-color-scheme: dark) {
  .emoji-verification-instructions {
    color: #b0b0b0;
  }

  .emoji-verification-item {
    background: #2a2a2a;
  }

  .emoji-verification-item:hover {
    background: #333;
  }

  .emoji-verification-name {
    color: #999;
  }

  .emoji-verification-waiting p,
  .emoji-verification-error p {
    color: #b0b0b0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/verification/EmojiVerificationScreen.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,0DAA0D;IAC1D,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,cAAc;EAChB;AACF","sourcesContent":["/**\n * Styles for EmojiVerificationScreen component\n * Reusable component for any verification type\n */\n\n.emoji-verification-screen {\n  width: 100%;\n  min-height: 300px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.emoji-verification-content {\n  width: 100%;\n  max-width: 500px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* Instructions */\n.emoji-verification-instructions {\n  margin-bottom: 30px;\n  font-size: 16px;\n  color: #666;\n  text-align: center;\n  line-height: 1.5;\n}\n\n/* Emoji Grid */\n.emoji-verification-emojis {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));\n  gap: 15px;\n  width: 100%;\n  max-width: 450px;\n  margin-bottom: 30px;\n  padding: 0 10px;\n}\n\n.emoji-verification-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 15px 10px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  min-height: 90px;\n}\n\n.emoji-verification-item:hover {\n  background: #e9ecef;\n  transform: translateY(-2px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.emoji-verification-icon {\n  font-size: 36px;\n  margin-bottom: 8px;\n  line-height: 1;\n  user-select: none;\n}\n\n.emoji-verification-name {\n  font-size: 12px;\n  color: #666;\n  text-align: center;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\n/* Actions */\n.emoji-verification-actions {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n  max-width: 400px;\n  padding: 0 10px;\n}\n\n.emoji-verification-actions .btn {\n  flex: 1;\n  padding: 12px 24px;\n  font-size: 15px;\n  font-weight: 600;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.emoji-verification-reject {\n  background: #dc3545;\n  color: white;\n  border: none;\n}\n\n.emoji-verification-reject:hover:not(:disabled) {\n  background: #c82333;\n  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);\n}\n\n.emoji-verification-confirm {\n  background: #28a745;\n  color: white;\n  border: none;\n}\n\n.emoji-verification-confirm:hover:not(:disabled) {\n  background: #218838;\n  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);\n}\n\n.emoji-verification-actions .btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Waiting State */\n.emoji-verification-waiting {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 60px 20px;\n  text-align: center;\n}\n\n.emoji-verification-waiting .spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #f0f0f0;\n  border-top: 3px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n.emoji-verification-waiting p {\n  font-size: 16px;\n  color: #666;\n  margin: 0;\n}\n\n/* Error State */\n.emoji-verification-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 60px 20px;\n  text-align: center;\n}\n\n.emoji-verification-error p {\n  font-size: 16px;\n  color: #dc3545;\n  margin: 0;\n}\n\n/* Spinner animation */\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Responsive adjustments */\n@media (max-width: 600px) {\n  .emoji-verification-emojis {\n    grid-template-columns: repeat(auto-fit, minmax(70px, 1fr));\n    gap: 10px;\n  }\n\n  .emoji-verification-item {\n    padding: 12px 8px;\n    min-height: 80px;\n  }\n\n  .emoji-verification-icon {\n    font-size: 30px;\n  }\n\n  .emoji-verification-name {\n    font-size: 11px;\n  }\n\n  .emoji-verification-actions {\n    flex-direction: column;\n  }\n\n  .emoji-verification-actions .btn {\n    width: 100%;\n  }\n}\n\n/* Dark theme support */\n@media (prefers-color-scheme: dark) {\n  .emoji-verification-instructions {\n    color: #b0b0b0;\n  }\n\n  .emoji-verification-item {\n    background: #2a2a2a;\n  }\n\n  .emoji-verification-item:hover {\n    background: #333;\n  }\n\n  .emoji-verification-name {\n    color: #999;\n  }\n\n  .emoji-verification-waiting p,\n  .emoji-verification-error p {\n    color: #b0b0b0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
